import React, { useState } from 'react';
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { Image } from '@/components/ui/image';
import { PORTFOLIO, PORTFOLIO_FILTERS } from '@/data/portfolio';
import PortfolioTile from '@/components/portfolio/PortfolioTile';

export default function PortfolioSection() {
  const [filter, setFilter] = useState('All');
  const [active, setActive] = useState(null);
  const items = filter === 'All' ? PORTFOLIO : PORTFOLIO.filter((p) => p.category === filter);

  return (
    <section id="portfolio" className="bg-[#0B0B0B] border-t border-white/10 py-16 lg:py-24">
      <div className="max-w-[1320px] mx-auto px-6 lg:px-10">
        <p className="text-[10px] uppercase tracking-[0.2em] text-[#3B82F6]">Selected Work</p>
        <div className="mt-4 flex flex-col lg:flex-row lg:items-end justify-between gap-6">
          <h2 className="font-display font-bold text-white text-3xl lg:text-[2.75rem] tracking-tight max-w-2xl leading-tight">
            Production portfolio
          </h2>
          <div className="flex flex-wrap gap-2">
            {PORTFOLIO_FILTERS.map((f) => (
              <button
                key={f}
                type="button"
                onClick={() => setFilter(f)}
                className={`px-4 h-9 rounded-full text-xs font-semibold border transition-colors ${
                  filter === f ? 'bg-[#2563EB] border-[#2563EB] text-white' : 'border-white/15 text-white/60 hover:text-white hover:border-white/40'
                }`}
              >
                {f}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 lg:auto-rows-[280px] gap-5">
          {items.map((item) => (
            <PortfolioTile key={item.title} item={item} onOpen={setActive} />
          ))}
        </div>
      </div>

      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent className="max-w-4xl bg-[#0B0B0B] border-white/10 p-0 overflow-hidden">
          {active && (
            <>
              <Image src={active.src} alt={active.title} fittingType="fit" className="w-full h-[70vh]" />
              <div className="p-5">
                <DialogTitle className="font-display text-white">{active.title}</DialogTitle>
                <p className="text-sm text-white/60 mt-1">{active.client} · {active.category}</p>
              </div>
            </>
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
}